// namespace
window.Components = window.Components || {};

(function($) {

  'use strict';

  function seemoreItem() {

    var self = this,
        $cache = {},
        isOpen = false;
    
    /**
     * Open faq
     */
    function open() {
      if(isOpen) return;
      isOpen = true;

      var tl = new TimelineMax({paused: true});
      tl.add(function(){
        $cache.siblingItems.trigger('closeOther');
        $cache.main.addClass('is-open');
        $cache.head.attr('aria-expanded', true);
        $cache.content.attr('aria-hidden', false);
      }, 0);
      tl.to($cache.content, 0.5, {height: $cache.contentInner.outerHeight(), force3D: true, ease: Quad.easeOut}, 0);
      tl.fromTo($cache.contentInner, 0.6, {y: 30}, {y: 0, ease: Circ.easeOut}, 0.1);
      tl.fromTo($cache.contentInner, 0.5, {opacity: 0}, {opacity: 1, ease: Quad.easeOut}, 0.1);

      tl.play();      
    }
    
    /**
     * Close faq
     */
    function close() {
      if(!isOpen) return;
      isOpen = false;

      var tl = new TimelineMax({paused: true});
      tl.add(function(){
        $cache.main.removeClass('is-open');
        $cache.head.attr('aria-expanded', false);
        $cache.content.attr('aria-hidden', true);
      }, 0);
      tl.to($cache.content, 0.5, {height: 0, ease: Quad.easeOut}, 0);
      tl.to($cache.contentInner, 0.4, {opacity: 0, ease: Expo.easeOut}, 0.1);

      tl.play();      
    }
    
    /**
     * Toggle faq
     */
    function toggle() {
      if(isOpen) {
        close();
      } else {
        open();
      }
    }

    /**
     * Resize Event Handler
     */
    function onResize() {
      var bpLastValue = window.bp.getLastValue();
      var bpValue = window.bp.getValue();

      // On breakpoint change
      if (bpLastValue !== bpValue || bpValue === 'xs') {
        if(isOpen) {
          $cache.content.height($cache.contentInner.outerHeight());
        }
      }
    }
    
    /**
     * Init Cache
     */
    function initCache(target) {
      $cache.main = target;
      $cache.head = $cache.main.find('.js-seemore-head');
      $cache.content = $cache.main.find('.js-seemore-content');
      $cache.contentInner = $cache.main.find('.js-seemore-content-inner');
      $cache.siblingItems = $cache.main.parent().find('.js-seemore').not($cache.main);
    }

    /**
     * Register Events
     */
    function registerEvents() {
      window.cache.$window.on('resize', onResize);
      $cache.head.on('click', toggle);
      $cache.head.on('keydown', function(event){
        if ( event.which == 13 || event.which == 32) {
          event.preventDefault();
          $cache.head.trigger('click');
        }
      });
      $cache.main.on('closeOther', close);
    }

    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(target) {      
      initCache(target);
      registerEvents();
      
      //Initial call
      if($cache.main.hasClass('is-open')) open();
    };

    self.initialize.apply(self, arguments);
    return self;
  }
  
  window.Components.seemoreItem = seemoreItem;
  
}(jQuery));
